import Icon from "components/atoms/icon/Icon";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import DeleteCustomer from "../delete-customer-modal/DeleteCustomer";

export const TableActionButton = ({ id }: any) => {
    const [ThreeDotsOpen, setThreeDotsOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef<any>(null);
    const dropdownRef = useRef<any>(null);

    const handleClick = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const dropdownWidth = 200;
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.right + window.scrollX - dropdownWidth,
            });
        }
        setThreeDotsOpen(!ThreeDotsOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                ThreeDotsOpen &&
                buttonRef.current &&
                dropdownRef.current &&
                !buttonRef.current.contains(event.target) &&
                !dropdownRef.current.contains(event.target)
            ) {
                setThreeDotsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [ThreeDotsOpen]);

    const { t } = useTranslation();


    const [IsModalOpen, setIsModalOpen] = useState(false)

    return (
        <div className="flex flex-row items-center w-fit">
            <div className="relative">
                <button
                    ref={buttonRef}
                    type="button"
                    className="pl-5"
                    onClick={handleClick}
                >
                    <Icon iconType={IconType.OPTIONS_ICON} />
                </button>
                {ThreeDotsOpen &&
                    ReactDOM.createPortal(
                        <div
                            style={{
                                position: "absolute",
                                top: `${dropdownPosition.top}px`,
                                left: `${dropdownPosition.left}px`,
                            }}
                            ref={dropdownRef}
                        >
                            <div className="shadow-custom py-[15px] px-[21px]  w-[193px]  bg-white flex flex-col text-[14px] gap-1 font-inter-medium rounded-[12px]">
                                <div
                                    className=" flex flex-row items-center cursor-pointer"
                                    onClick={() => {
                                        setIsModalOpen(true);
                                        setThreeDotsOpen(false);
                                    }}
                                >
                                    <div>
                                        <Icon iconType={IconType.DELETE_SOURCE_ICON} />
                                    </div>
                                    <div className="px-3 text-[14px] font-inter-medium">
                                        {t('Delete')}
                                    </div>
                                </div>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
            <DeleteCustomer
                id={id}
                hocTitle="Are you sure?"
                hocisOpen={IsModalOpen}
                hocToggleModal={() => { setIsModalOpen(!IsModalOpen); }}
                hocCurrentStep={1}
                hocClasses={{
                    modalClassName: 'w-full sm:max-w-[560px]',
                }}
            />
        </div>
    );
};